<div #tileNavContainer class="tile-nav-container" [dir]="direction">
  <div #flat class="tile-nav-flat" [class.hidden]="nestedView">
    @for (item of dataSource; track item; let index = $index) {
      <div class="tile-nav-item">
        @if (index > 0) {
          <i
            [class]="direction === 'ltr' ? 'arrow-right-icon dx-icon-spinright ' : 'arrow-left-icon dx-icon-spinleft'"
            >
          </i>
        }
        <p
          #captions
          [class]="getItemState(item)"
          (click)="onTileClick(item)"
          [ngStyle]="{ 'min-width': item === dataSource[dataSource.length - 1] ? '70px' : 'auto' }"
          >
          {{ getItemCaption(item) }}
        </p>
      </div>
    }
  </div>

  <div #nested class="tile-nav-nested" [class.hidden]="!nestedView">
    <div class="tile-nav-item" [class]="getItemState(dataSource[0])" (click)="onTileClick(dataSource[0])">
      <p #nestedFirstCaption>{{ getItemCaption(dataSource[0]) }}</p>
    </div>
    <i
      id="menu-toggler"
      class="more-icon dx-icon-more"
      [style]="direction === 'ltr' ? { 'margin-left': '5px' } : { 'margin-right': '5px' }"
      (click)="openMenu()"
      >
      @if (menuOpen) {
        <div #menu class="tile-nav-menu-container" [class.fill]="fillContent">
          @for (item of menuDataSource; track item; let index = $index) {
            @if (index > 0) {
              <div class="hr"></div>
            }
            <div class="tile-nav-menu-item" [class]="getItemState(item)" (click)="onTileClick(item)">
              <p #nestedCaptions>{{ getItemCaption(item) }}</p>
            </div>
          }
        </div>
      }
    </i>
    <div class="tile-nav-item" style="margin-left: 10px" (click)="onTileClick(dataSource[dataSource.length - 1])">
      <p
        #nestedLastCaption
        [class]="getItemState(dataSource[dataSource.length - 1])"
        style="min-width: 70px; cursor: default !important"
        >
        {{ getItemCaption(dataSource[dataSource.length - 1]) }}
      </p>
    </div>
  </div>
</div>
